/**
 * Terminal Routes Constants
 */

export const TERMINAL_ROUTES = {
  HOME: '/terminal',
} as const;
